import { callApiToServer } from "../callApi";

export async function changeStatus(authtoken, subUserId, status) {
  try {
    let header = {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: "Berear " + authtoken,
    };

    let body = JSON.stringify({
      subUserId: subUserId,
      flag: status,
    });

    let endUrl = "v1/auth/sub-user/status";

    let responseData = await callApiToServer(body, header, "POST", endUrl);

    return responseData;
  } catch (err) {
    throw err;
  }
}
